import {
    ListarTelefonesPorContaService,
} from "../../../Services/Geral/ContaTelefone/ContaTelefoneService";
import { Controller } from "../../Controller";
export async function ListarTelefonesPorContaController(
    idConta: number
) {
    return Controller(ListarTelefonesPorContaService(idConta));
}